/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDefinitionDtoValueType } from './CreateDefinitionDtoValueType';
import {
    CreateDefinitionDtoValueTypeFromJSON,
    CreateDefinitionDtoValueTypeFromJSONTyped,
    CreateDefinitionDtoValueTypeToJSON,
} from './CreateDefinitionDtoValueType';

/**
 * 
 * @export
 * @interface DefinitionParameterValueDto
 */
export interface DefinitionParameterValueDto {
    /**
     * 
     * @type {string}
     * @memberof DefinitionParameterValueDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DefinitionParameterValueDto
     */
    setIdentifier: string;
    /**
     * 
     * @type {string}
     * @memberof DefinitionParameterValueDto
     */
    parameterIdentifier: string;
    /**
     * 
     * @type {number}
     * @memberof DefinitionParameterValueDto
     */
    value: number;
    /**
     * 
     * @type {CreateDefinitionDtoValueType}
     * @memberof DefinitionParameterValueDto
     */
    valueType?: CreateDefinitionDtoValueType | null;
    /**
     * 
     * @type {number}
     * @memberof DefinitionParameterValueDto
     */
    decimalPlaces?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DefinitionParameterValueDto
     */
    unitAbbreviation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DefinitionParameterValueDto
     */
    $type?: DefinitionParameterValueDtoTypeEnum;
}


/**
 * @export
 */
export const DefinitionParameterValueDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoDefinitionParameterValueDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.DefinitionParameterValueDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type DefinitionParameterValueDtoTypeEnum = typeof DefinitionParameterValueDtoTypeEnum[keyof typeof DefinitionParameterValueDtoTypeEnum];


/**
 * Check if a given object implements the DefinitionParameterValueDto interface.
 */
export function instanceOfDefinitionParameterValueDto(value?: unknown): value is DefinitionParameterValueDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(DefinitionParameterValueDtoTypeEnum)[0];
}

export function DefinitionParameterValueDtoFromJSON(json: any): DefinitionParameterValueDto {
    return DefinitionParameterValueDtoFromJSONTyped(json, false);
}

export function DefinitionParameterValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DefinitionParameterValueDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'setIdentifier': json['setIdentifier'],
        'parameterIdentifier': json['parameterIdentifier'],
        'value': json['value'],
        'valueType': !exists(json, 'valueType') ? undefined : CreateDefinitionDtoValueTypeFromJSON(json['valueType']),
        'decimalPlaces': !exists(json, 'decimalPlaces') ? undefined : json['decimalPlaces'],
        'unitAbbreviation': !exists(json, 'unitAbbreviation') ? undefined : json['unitAbbreviation'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function DefinitionParameterValueDtoToJSON(value?: DefinitionParameterValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'setIdentifier': value.setIdentifier,
        'parameterIdentifier': value.parameterIdentifier,
        'value': value.value,
        'valueType': CreateDefinitionDtoValueTypeToJSON(value.valueType),
        'decimalPlaces': value.decimalPlaces,
        'unitAbbreviation': value.unitAbbreviation,
        '$type': value.$type,
    });
}

